<template>
    <div class="product-link">
        <h2 class="subtitle">Bundles</h2>
        <div>
            <div v-if="productBundles.length < 1">
                This product does not belong to a bundle
                <br/>
            </div>
            <div v-for="bundle in productBundles">
                <router-link :to="{ name: 'bundle', params: {id: bundle.id}}">
                    {{ bundle.name }}
                </router-link>
                <a class="delete" @click="remove(bundle)"></a>
            </div>
        </div>
        <br/>
        <div v-if="!adding">
            <a class="button is-small" @click="adding = true">Add to bundle...</a>
        </div>
        <div v-if="adding">
            <p class="control">
                <span class="select">
                    <select name="bundle-add" @change="add($event.target.value)">
                        <option>Select a bundle...</option>
                        <option v-for="bundle in availableBundles" :value="bundle.id">{{ bundle.name }}</option>
                    </select>
                </span>
                <button type="button" class="button" @click="adding = false">Cancel</button>
            </p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {CREATE_PRODUCT_BUNDLE, DELETE_PRODUCT_BUNDLE} from "../../store/mutation-types"
    import sortAlphaNum from "../../utils/sortAlphaNum"
    export default {
        props: ['productId'],
        data() {
            return {
                adding: false,
            }
        },
        computed: Object.assign({}, mapGetters(['bundles']), {
            availableBundles () {
                let bundles = this.$store.state.products.product_bundles.filter(bundle => bundle.product_id === this.productId)
                let ids     = []
                for (let bundle in bundles) {
                    ids.push(bundles[bundle].bundle_id)
                }
                return this.bundles.filter(bundle => ids.indexOf(bundle.id) === -1).sort((a, b) => sortAlphaNum(a.name, b.name))
            },
            productBundles () {
                let bundles = this.$store.state.products.product_bundles.filter(bundle => bundle.product_id === this.productId)
                let ids     = []
                for (let bundle in bundles) {
                    ids.push(bundles[bundle].bundle_id)
                }
                return this.bundles.filter(bundle => ids.indexOf(bundle.id) !== -1).map(bundle => {
                    return Object.assign(bundle, {
                        link_id: bundles.find(b => b.bundle_id === bundle.id).id
                    })
                })
            }
        }),
        methods: {
            add(bundle) {
                this.$store.dispatch(CREATE_PRODUCT_BUNDLE, {
                    product_id: this.productId,
                    bundle_id: bundle
                })
                this.adding = false
            },
            remove(bundle) {
                this.$store.dispatch(DELETE_PRODUCT_BUNDLE, {
                    id: bundle.link_id,
                    product_id: this.productId,
                    bundle_id: bundle.id,
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ProductBundles.vue?3a598d30